import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API, timeout: 90000 });

export const adminApi = axios.create({ baseURL: API, timeout: 30000 });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("spm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/atm-seguros") && !window.location.pathname.endsWith("/login")) {
      localStorage.removeItem("spm_token");
      window.location.href = "/atm-seguros/login";
    }
    return Promise.reject(err);
  }
);

export function errorMessage(err, fallback = "Ocurrio un error. Intenta de nuevo.") {
  const res = err?.response;
  if (!res) return "No hay conexion. Verifica tu internet e intenta de nuevo.";
  if (res.status >= 500 || typeof res.data !== "object" || res.data === null) return fallback;
  const detail = res.data?.detail;
  if (Array.isArray(detail)) return detail.filter(Boolean).join(" ");
  if (typeof detail === "string") return detail;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}

export function fmtMoney(value) {
  const n = parseFloat(String(value).replace(",", "."));
  if (isNaN(n)) return "-";
  return new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 2 }).format(n);
}

export const ESTADOS = {
  cotizado: { label: "Cotizado", cls: "bg-slate-100 text-slate-700" },
  guardado: { label: "Guardado (pago diferido)", cls: "bg-indigo-100 text-indigo-800" },
  solicitud_robo: { label: "Solicitud robo", cls: "bg-sky-100 text-sky-800" },
  emitido: { label: "Emitido", cls: "bg-emerald-100 text-emerald-800" },
  pendiente_pago: { label: "Pendiente de pago", cls: "bg-amber-100 text-amber-800" },
  pendiente_inspeccion: { label: "Pend. inspeccion", cls: "bg-orange-100 text-orange-800" },
  solicitud_manual: { label: "Lista p/ emitir (manual)", cls: "bg-blue-100 text-blue-800" },
  cancelado: { label: "Cancelado", cls: "bg-red-100 text-red-700" },
  poliza_vigente: { label: "Poliza vigente", cls: "bg-green-100 text-green-800" },
  anulado: { label: "Anulado", cls: "bg-red-100 text-red-800" },
};
